// extracted by mini-css-extract-plugin
export default {"cookieBanner":"CookieBanner_cookieBanner__QopOS","content":"CookieBanner_content__df4Rc","title":"CookieBanner_title__qeJKz","buttons":"CookieBanner_buttons__RspK+"};